import { render, staticRenderFns } from "./LeftColumn.vue?vue&type=template&id=5c7ff061&"
import script from "./LeftColumn.vue?vue&type=script&lang=js&"
export * from "./LeftColumn.vue?vue&type=script&lang=js&"
import style0 from "./LeftColumn.vue?vue&type=style&index=0&id=5c7ff061&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports